// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Pagination,
//   Card,
//   TextField,
//   Box,
//   Stack,
//   IconButton,
//   Skeleton,
//   Typography,
//   Chip,
//   Avatar,
//   InputAdornment,
//   useTheme,
//   alpha,
//   Alert,
//   Fade,
//   LinearProgress,
//   PaginationItem,
//   CircularProgress,
// } from "@mui/material";
// import { 
//   MdInbox, 
//   MdVisibility, 
//   MdSearch, 
//   MdClear, 
//   MdError,
//   MdCheckCircle,
//   MdSchedule,
//   MdCancel,
//   MdHourglassEmpty,
//   MdArrowBack,
//   MdArrowForward
// } from "react-icons/md";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import debounce from "lodash.debounce";
// import dayjs from "dayjs";
// import PrescriptionOrder from "./Prescription_order";
// import { getTimeStatus } from "utils/getTimeStatus";
// import { getTimeStatusWithStatus } from "utils/getTimeStatus";

// const OfferList = () => {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const [data, setData] = useState({ list: [], totalCount: 0, totalPages: 1, currentPage: 1 });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [error, setError] = useState(null);
//   const [searchLoading, setSearchLoading] = useState(false);

//   const fetchData = useCallback(
//     debounce(async (page, query) => {
//       setLoading(true);
//       setSearchLoading(true);
//       setError(null);
      
//       try {
//         const { data: responseData } = await axios.get(
//           `https://api.medstown.com/customer/open/orders?page=${page}&search=${query}`
//         );
        
//         // Update data state with the complete response
//         setData(responseData);
        
//         // Ensure currentPage is in sync with response
//         if (responseData.currentPage) {
//           setCurrentPage(responseData.currentPage);
//         }
        
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         setError(error.response?.data?.message || "Failed to fetch orders. Please try again.");
//         setData({ list: [], totalCount: 0, totalPages: 1, currentPage: 1 });
//       } finally {
//         setLoading(false);
//         setSearchLoading(false);
//       }
//     }, 500),
//     []
//   );

//   useEffect(() => {
//     fetchData(currentPage, searchQuery);
//   }, [currentPage, searchQuery, fetchData]);

//   const handlePageChange = (event, value) => {
//     setCurrentPage(value);
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1); // Reset to first page when searching
//     setSearchLoading(true);
//   };

//   const clearSearch = () => {
//     setSearchQuery("");
//     setCurrentPage(1);
//   };

//   const getStatusConfig = (status) => {
//     const configs = {
//       "Pending": {
//         color: "#ff9800",
//         bgColor: alpha("#ff9800", 0.1),
//         icon: <MdSchedule size={12} />
//       },
//             "pending": {
//         color: "#ff9800",
//         bgColor: alpha("#ff9800", 0.1),
//         icon: <MdSchedule size={12} />
//       },
//                   "accepted": {
//         color: "#ff9800",
//         bgColor: alpha("#ff9800", 0.1),
//         icon: <MdSchedule size={12} />
//       },
//       "Processing": {
//         color: "#2196f3",
//         bgColor: alpha("#2196f3", 0.1),
//         icon: <MdHourglassEmpty size={12} />
//       },
//       "Confirmed": {
//         color: "#9c27b0",
//         bgColor: alpha("#9c27b0", 0.1),
//         icon: <MdCheckCircle size={12} />
//       },
//       "Delivered": {
//         color: "#4caf50",
//         bgColor: alpha("#4caf50", 0.1),
//         icon: <MdCheckCircle size={12} />
//       },
//       "Order Cancelled": {
//         color: "#f44336",
//         bgColor: alpha("#f44336", 0.1),
//         icon: <MdCancel size={12} />
//       },
//       "Cancelled": {
//         color: "#f44336",
//         bgColor: alpha("#f44336", 0.1),
//         icon: <MdCancel size={12} />
//       }
//     };
//     return configs[status] || {
//       color: "#757575",
//       bgColor: alpha("#757575", 0.1),
//       icon: <MdSchedule size={12} />
//     };
//   };

//   const getPaymentTypeConfig = (type) => {
//     const configs = {
//       "COD": {
//         color: "#ff5722",
//         bgColor: alpha("#ff5722", 0.1)
//       },
//       "online": {
//         color: "#4caf50",
//         bgColor: alpha("#4caf50", 0.1)
//       },
//       "UPI": {
//         color: "#673ab7",
//         bgColor: alpha("#673ab7", 0.1)
//       },
//       "Card": {
//         color: "#009688",
//         bgColor: alpha("#009688", 0.1)
//       }
//     };
//     return configs[type] || {
//       color: "#757575",
//       bgColor: alpha("#757575", 0.1)
//     };
//   };

//   return (
//     <>
//       <Card sx={{ 
//         mt: 3, 
//         borderRadius: 3, 
//         boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
//         border: '1px solid',
//         borderColor: alpha(theme.palette.divider, 0.1),
//         overflow: 'hidden'
//       }}>
//         {/* Loading Progress Bar */}
//         {loading && (
//           <LinearProgress 
//             sx={{ 
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               right: 0,
//               zIndex: 1,
//               height: 3,
//               '& .MuiLinearProgress-bar': {
//                 background: 'linear-gradient(90deg, #2196f3, #21cbf3, #2196f3)'
//               }
//             }} 
//           />
//         )}

//         {/* Header with Advanced Search */}
//         <Box sx={{ p: 3, pb: 2 }}>
//           <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={3}>
//             <Box>
//               <Typography variant="h5" fontWeight={700} color="primary.main" sx={{ mb: 0.5 }}>
//                 Order Management
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 {/* {data?.totalCount || 0} total orders • Page {data?.currentPage || 1} of {data?.totalPages || 1} */}
//               </Typography>
//             </Box>

//             {/* Advanced Search Bar */}
//             <Box sx={{ position: 'relative' }}>
//               <TextField
//                 variant="outlined"
//                 size="medium"
//                 placeholder="Search by Order ID, Customer Name, or Phone..."
//                 value={searchQuery}
//                 onChange={handleSearch}
//                 sx={{
//                   width: 400,
//                   '& .MuiOutlinedInput-root': {
//                     backgroundColor: alpha(theme.palette.background.paper, 0.8),
//                     backdropFilter: 'blur(10px)',
//                     borderRadius: 3,
//                     fontSize: '0.875rem',
//                     transition: 'all 0.3s ease',
//                     '& fieldset': {
//                       borderColor: alpha(theme.palette.primary.main, 0.2),
//                       borderWidth: 2,
//                     },
//                     '&:hover': {
//                       backgroundColor: alpha(theme.palette.background.paper, 1),
//                       '& fieldset': {
//                         borderColor: alpha(theme.palette.primary.main, 0.4),
//                       },
//                     },
//                     '&.Mui-focused': {
//                       backgroundColor: alpha(theme.palette.background.paper, 1),
//                       boxShadow: `0 0 0 4px ${alpha(theme.palette.primary.main, 0.1)}`,
//                       '& fieldset': {
//                         borderColor: theme.palette.primary.main,
//                       },
//                     },
//                   },
//                 }}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       {searchLoading ? (
//                         <CircularProgress size={18} thickness={4} />
//                       ) : (
//                         <MdSearch size={20} color={theme.palette.primary.main} />
//                       )}
//                     </InputAdornment>
//                   ),
//                   endAdornment: searchQuery && (
//                     <InputAdornment position="end">
//                       <IconButton
//                         size="small"
//                         onClick={clearSearch}
//                         sx={{ 
//                           color: theme.palette.text.secondary,
//                           '&:hover': { 
//                             backgroundColor: alpha(theme.palette.error.main, 0.1),
//                             color: theme.palette.error.main 
//                           }
//                         }}
//                       >
//                         <MdClear size={18} />
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Box>
//           </Stack>

//           {/* Error Alert */}
//           {error && (
//             <Fade in={!!error}>
//               <Alert 
//                 severity="error" 
//                 sx={{ mt: 2, borderRadius: 2 }}
//                 icon={<MdError />}
//                 action={
//                   <IconButton
//                     size="small"
//                     onClick={() => setError(null)}
//                     sx={{ color: 'inherit' }}
//                   >
//                     <MdClear size={16} />
//                   </IconButton>
//                 }
//               >
//                 {error}
//               </Alert>
//             </Fade>
//           )}
//         </Box>

//         <TableContainer sx={{ px: 3 }}>
//           <Table size="small" sx={{ '& .MuiTableCell-root': { py: 2 } }}>
//             <TableHead>
//               <TableRow sx={{ '& .MuiTableCell-head': { 
//                 backgroundColor: alpha(theme.palette.primary.main, 0.06),
//                 fontWeight: 700,
//                 fontSize: '0.8rem',
//                 color: theme.palette.primary.main,
//                 border: 'none',
//                 py: 2,
//                 textTransform: 'uppercase',
//                 letterSpacing: '0.5px'
//               }}}>
//                 <TableCell>Order ID</TableCell>
//                 <TableCell>Type</TableCell>
//                 <TableCell>Customer</TableCell>
//                 <TableCell>Phone</TableCell>
//                 <TableCell align="right">Amount</TableCell>
//                 <TableCell>Payment</TableCell>
//                 <TableCell>Status</TableCell>
//                 <TableCell>Duration</TableCell>
//                 <TableCell>Created</TableCell>
//                 <TableCell align="center">Action</TableCell>
//               </TableRow>
//             </TableHead>

//             <TableBody>
//               {loading && !data?.list?.length ? (
//                 Array.from(new Array(6)).map((_, index) => (
//                   <TableRow key={index}>
//                     {[...Array(10)].map((_, i) => (
//                       <TableCell key={i}>
//                         <Skeleton 
//                           variant="rectangular" 
//                           height={28} 
//                           sx={{ borderRadius: 1.5, bgcolor: alpha(theme.palette.primary.main, 0.05) }} 
//                         />
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 ))
//               ) : data?.list?.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={10} align="center" sx={{ py: 8 }}>
//                     <Stack direction="column" alignItems="center" spacing={3}>
//                       <Avatar sx={{ 
//                         bgcolor: alpha(theme.palette.primary.main, 0.1),
//                         width: 72,
//                         height: 72
//                       }}>
//                         <MdInbox size={36} color={theme.palette.primary.main} />
//                       </Avatar>
//                       <Box textAlign="center">
//                         <Typography variant="h6" color="text.primary" fontWeight={600} sx={{ mb: 1 }}>
//                           No orders found
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                           {searchQuery ? 'Try adjusting your search terms' : 'No orders available at the moment'}
//                         </Typography>
//                       </Box>
//                     </Stack>
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 data?.list?.map((item) => {
//                   const statusConfig = getStatusConfig(item.status);
//                   const paymentConfig = getPaymentTypeConfig(item.paymentType);
                  
//                   return (
//                     <TableRow 
//                       key={item._id}
//                       sx={{ 
//                         '&:hover': { 
//                           backgroundColor: alpha(theme.palette.primary.main, 0.03),
//                           transform: 'translateY(-1px)',
//                           boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.1)}`
//                         },
//                         borderBottom: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
//                         transition: 'all 0.2s ease'
//                       }}
//                     >
//                       <TableCell sx={{ fontSize: '0.8125rem', fontWeight: 600 }}>
//                         <Box component="span" sx={{ 
//                           color: theme.palette.primary.main,
//                           fontFamily: 'monospace',
//                           backgroundColor: alpha(theme.palette.primary.main, 0.08),
//                           px: 1,
//                           py: 0.5,
//                           borderRadius: 1,
//                           fontSize: '0.75rem'
//                         }}>
//                           {item.orderId}
//                         </Box>
//                       </TableCell>
                      
//                       <TableCell sx={{ fontSize: '0.8125rem' }}>
//                         <Chip 
//                           label={item.orderType?.replace("Pharmacy", "").trim()}
//                           size="small"
//                           variant="outlined"
//                           sx={{ 
//                             fontSize: '0.7rem', 
//                             height: 26,
//                             borderColor: alpha(theme.palette.secondary.main, 0.4),
//                             color: theme.palette.secondary.main,
//                             fontWeight: 500
//                           }}
//                         />
//                       </TableCell>
                      
//                       <TableCell sx={{ fontSize: '0.8125rem', maxWidth: 120 }}>
//                         <Box sx={{ 
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis',
//                           whiteSpace: 'nowrap',
//                           fontWeight: 500
//                         }}>
//                           {item.customerName}
//                         </Box>
//                       </TableCell>
                      
//                       <TableCell sx={{ fontSize: '0.8125rem', fontFamily: 'monospace' }}>
//                         {item.customerPhone}
//                       </TableCell>
                      
//                       <TableCell align="right" sx={{ fontSize: '0.8125rem', fontWeight: 700 }}>
//                         <Box sx={{ color: theme.palette.success.main }}>
//                           ₹{item.totalPrice?.toLocaleString()}
//                         </Box>
//                       </TableCell>
                      
//                       <TableCell sx={{ fontSize: '0.8125rem' }}>
//                         <Chip 
//                           label={item.paymentType}
//                           size="small"
//                           sx={{ 
//                             fontSize: '0.7rem',
//                             height: 24,
//                             backgroundColor: paymentConfig.bgColor,
//                             color: paymentConfig.color,
//                             border: 'none',
//                             fontWeight: 600
//                           }}
//                         />
//                       </TableCell>
                      
//                       <TableCell sx={{ fontSize: '0.8125rem' }}>
//                         <Chip 
//                           label={item.status}
//                           size="small"
//                           icon={statusConfig.icon}
//                           sx={{ 
//                             fontSize: '0.7rem',
//                             height: 26,
//                             backgroundColor: statusConfig.bgColor,
//                             color: statusConfig.color,
//                             border: `1px solid ${alpha(statusConfig.color, 0.3)}`,
//                             fontWeight: 600,
//                             '& .MuiChip-icon': {
//                               color: statusConfig.color,
//                               marginLeft: '4px'
//                             }
//                           }}
//                         />
//                       </TableCell>

//                       <TableCell sx={{ fontSize: '0.75rem', maxWidth: 100 }}>
//                         {item.status === "Delivered" || item.status === "Order Cancelled" ? (
//                           <Box sx={{ color: 'text.secondary' }}>
//                             {getTimeStatusWithStatus(item.createdAt, item.updatedAt, item.status)}
//                           </Box>
//                         ) : (
//                           <Box sx={{
//                             color: getTimeStatus(item.createdAt).includes("Time Exceeded") 
//                               ? 'error.main' 
//                               : 'text.secondary',
//                             fontWeight: getTimeStatus(item.createdAt).includes("Time Exceeded") ? 700 : 400
//                           }}>
//                             {getTimeStatus(item.createdAt)}
//                           </Box>
//                         )}
//                       </TableCell>

//                       <TableCell sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
//                         <Box sx={{ fontWeight: 500 }}>
//                           {dayjs(item.createdAt).format("MMM DD")}
//                         </Box>
//                         <Box sx={{ fontSize: '0.7rem', opacity: 0.8 }}>
//                           {dayjs(item.createdAt).format("hh:mm A")}
//                         </Box>
//                       </TableCell>
                      
//                       <TableCell align="center">
//                         <IconButton
//                           onClick={() => navigate(`/admin/open-order/${item.orderId}`)}
//                           size="small"
//                           sx={{ 
//                             color: theme.palette.primary.main,
//                             backgroundColor: alpha(theme.palette.primary.main, 0.1),
//                             border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
//                             '&:hover': {
//                               backgroundColor: alpha(theme.palette.primary.main, 0.2),
//                               transform: 'scale(1.05)',
//                               boxShadow: `0 4px 8px ${alpha(theme.palette.primary.main, 0.3)}`
//                             },
//                             transition: 'all 0.2s ease'
//                           }}
//                         >
//                           <MdVisibility size={16} />
//                         </IconButton>
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* Enhanced Pagination with Results Info */}
//         <Box sx={{ p: 3, pt: 2 }}>
//           <Stack direction="row" justifyContent="space-between" alignItems="center">
//             {/* Results Info */}
//             <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
//               Showing {data?.list?.length || 0} of {data?.totalCount || 0} orders
//             </Typography>

//             {/* Pagination */}
//             {data?.totalPages > 1 && (
//               <Pagination
//                 count={data?.totalPages || 1}
//                 page={currentPage}
//                 onChange={handlePageChange}
//                 size="medium"
//                 variant="outlined"
//                 shape="rounded"
//                 renderItem={(item) => (
//                   <PaginationItem
//                     slots={{ previous: MdArrowBack, next: MdArrowForward }}
//                     {...item}
//                     sx={{
//                       fontSize: '0.875rem',
//                       minWidth: 36,
//                       height: 36,
//                       margin: '0 2px',
//                       borderRadius: 2,
//                       border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
//                       '&.Mui-selected': {
//                         backgroundColor: theme.palette.primary.main,
//                         color: 'white',
//                         fontWeight: 600,
//                         border: `1px solid ${theme.palette.primary.main}`,
//                         '&:hover': {
//                           backgroundColor: alpha(theme.palette.primary.main, 0.8),
//                         }
//                       },
//                       '&:hover': {
//                         backgroundColor: alpha(theme.palette.primary.main, 0.1),
//                         borderColor: alpha(theme.palette.primary.main, 0.4),
//                       }
//                     }}
//                   />
//                 )}
//               />
//             )}
//           </Stack>
//         </Box>
//       </Card>

//       <PrescriptionOrder />
//     </>
//   );
// };

// export default OfferList;



import React, { useState, useEffect, useCallback } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  PaginationItem,
  Card,
  TextField,
  Box,
  Stack,
  IconButton,
  Skeleton,
  Typography,
  Chip,
  Avatar,
  InputAdornment,
  Alert,
  Fade,
  LinearProgress,
  CircularProgress,
  useTheme,
  alpha,
  useMediaQuery,
  Tooltip,
} from "@mui/material";
import {
  MdInbox,
  MdVisibility,
  MdSearch,
  MdClear,
  MdError,
  MdSchedule,
  MdHourglassEmpty,
  MdCheckCircle,
  MdCancel,
  MdArrowBack,
  MdArrowForward,
} from "react-icons/md";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import debounce from "lodash.debounce";
import dayjs from "dayjs";
import PrescriptionOrder from "./Prescription_order";
import {
  getTimeStatus,
  getTimeStatusWithStatus,
  getDeliveryTimingLabel,
  getDeliveryTimingIcon,
} from "utils/getTimeStatus";
import {
  Bolt as BoltIcon,
  Schedule as ScheduleIcon,
  RocketLaunch as RocketLaunchIcon,
  LocalShipping as LocalShippingIcon,
  WarningAmber as WarningAmberIcon,
} from "@mui/icons-material";

// Icon registry — keeps the helper's `iconName` strings decoupled from the
// MUI imports here. Render with: <TimingIconMap[name] sx={{...}} />.
const TimingIconMap = {
  Bolt: BoltIcon,
  Schedule: ScheduleIcon,
  RocketLaunch: RocketLaunchIcon,
  LocalShipping: LocalShippingIcon,
  WarningAmber: WarningAmberIcon,
};

const medstownColors = {
  primary: "#014D4D",
  secondary: "#02A0A0",
  accent: "#FFB800",
  success: "#4caf50",
  error: "#f44336",
  warning: "#ff9800",
  white: "#fff",
};

const statusConfigs = {
  pending: {
    color: medstownColors.warning,
    bgColor: alpha(medstownColors.warning, 0.15),
    icon: <MdSchedule size={14} />,
  },
  accepted: {
    color: medstownColors.warning,
    bgColor: alpha(medstownColors.warning, 0.15),
    icon: <MdSchedule size={14} />,
  },
  processing: {
    color: "#2196f3",
    bgColor: alpha("#2196f3", 0.15),
    icon: <MdHourglassEmpty size={14} />,
  },
  confirmed: {
    color: medstownColors.secondary,
    bgColor: alpha(medstownColors.secondary, 0.15),
    icon: <MdCheckCircle size={14} />,
  },
  delivered: {
    color: medstownColors.success,
    bgColor: alpha(medstownColors.success, 0.15),
    icon: <MdCheckCircle size={14} />,
  },
  cancelled: {
    color: medstownColors.error,
    bgColor: alpha(medstownColors.error, 0.15),
    icon: <MdCancel size={14} />,
  },
  "order cancelled": {
    color: medstownColors.error,
    bgColor: alpha(medstownColors.error, 0.15),
    icon: <MdCancel size={14} />,
  },
  default: {
    color: alpha("#757575", 0.87),
    bgColor: alpha("#757575", 0.12),
    icon: <MdSchedule size={14} />,
  },
};

const paymentConfigs = {
  COD: {
    color: "#ff5722",
    bgColor: alpha("#ff5722", 0.15),
  },
  online: {
    color: medstownColors.success,
    bgColor: alpha(medstownColors.success, 0.15),
  },
  UPI: {
    color: "#673ab7",
    bgColor: alpha("#673ab7", 0.15),
  },
  Card: {
    color: "#009688",
    bgColor: alpha("#009688", 0.15),
  },
  default: {
    color: alpha("#757575", 0.87),
    bgColor: alpha("#757575", 0.12),
  },
};

const OfferList = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [data, setData] = useState({ list: [], totalCount: 0, totalPages: 1, currentPage: 1 });
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);

  // Debounced fetch function
  const fetchData = useCallback(
    debounce(async (page, query) => {
      setLoading(true);
      setSearchLoading(true);
      setError(null);
      try {
        const { data: responseData } = await axios.get(
          `https://api.medstown.com/customer/open/orders?page=${page}&search=${query}`
        );
        setData(responseData);
        if (responseData.currentPage) {
          setCurrentPage(responseData.currentPage);
        }
      } catch (err) {
        setError(err.response?.data?.message || "Failed to fetch orders. Please try again.");
        setData({ list: [], totalCount: 0, totalPages: 1, currentPage: 1 });
      } finally {
        setLoading(false);
        setSearchLoading(false);
      }
    }, 500),
    []
  );

  useEffect(() => {
    fetchData(currentPage, searchQuery);
  }, [currentPage, searchQuery, fetchData]);

  const handlePageChange = (_event, page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
    setSearchLoading(true);
  };

  const clearSearch = () => {
    setSearchQuery("");
    setCurrentPage(1);
  };

  const getStatusConfig = (status) => statusConfigs[status.toLowerCase()] || statusConfigs.default;
  const getPaymentConfig = (type) => paymentConfigs[type] || paymentConfigs.default;

  return (
    <>
      <Card
        sx={{
          mt: 3,
          borderRadius: 3,
          boxShadow: `0 12px 24px ${alpha("#000", 0.05)}`,
          border: `1px solid ${alpha(theme.palette.divider, 0.12)}`,
          overflow: "hidden",
          position: "relative",
          minHeight: 400,
        }}
      >
        {/* Loading Progress Bar */}
        {loading && (
          <LinearProgress
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              zIndex: 10,
              "& .MuiLinearProgress-bar": {
                background: `linear-gradient(90deg, ${medstownColors.primary}, ${medstownColors.secondary}, ${medstownColors.primary})`,
              },
            }}
          />
        )}

        {/* Header */}
        <Box sx={{ p: { xs: 2, sm: 3 }, borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", sm: "center" }}
            spacing={{ xs: 2, sm: 0 }}
          >
            <Box>
              <Typography variant={isMobile ? "h6" : "h5"} fontWeight={700} color="primary.main" mb={{ xs: 1, sm: 0 }}>
                Order Management
              </Typography>
              {/* <Typography variant="body2" color="text.secondary">
                Showing {data.totalCount} orders • Page {currentPage} of {data.totalPages}
              </Typography> */}
            </Box>

            <TextField
              size={isMobile ? "small" : "medium"}
              placeholder="Search by Order ID, Name, or Phone..."
              value={searchQuery}
              onChange={handleSearch}
              sx={{
                width: { xs: "100%", sm: 350 },
                backgroundColor: alpha(theme.palette.background.paper, 0.85),
                borderRadius: 2,
                "& .MuiOutlinedInput-root": {
                  fontSize: "0.875rem",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {searchLoading ? (
                      <CircularProgress size={18} color="primary" />
                    ) : (
                      <MdSearch size={20} color={theme.palette.primary.main} />
                    )}
                  </InputAdornment>
                ),
                endAdornment:
                  searchQuery && (
                    <InputAdornment position="end">
                      <IconButton size="small" onClick={clearSearch} aria-label="Clear search">
                        <MdClear size={18} />
                      </IconButton>
                    </InputAdornment>
                  ),
              }}
            />
          </Stack>
          {error && (
            <Fade in={Boolean(error)}>
              <Alert
                severity="error"
                sx={{ mt: 2, borderRadius: 2 }}
                onClose={() => setError(null)}
                icon={<MdError />}
              >
                {error}
              </Alert>
            </Fade>
          )}
        </Box>

        {/* Table */}
        <TableContainer
          sx={{
            maxHeight: "55vh",
            overflowX: "auto",
          }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: alpha(theme.palette.primary.main, 0.1),
                  "& th": {
                    color: theme.palette.primary.main,
                    fontWeight: 700,
                    fontSize: 13,
                    textTransform: "uppercase",
                    letterSpacing: 0.5,
                    py: { xs: 0.8, sm: 1.2 },
                    borderBottom: "none",
                    whiteSpace: "nowrap",
                  },
                }}
              >
                <TableCell>ID</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Customer</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell align="right">Amount</TableCell>
                <TableCell>Payment</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Duration</TableCell>
                <TableCell>Created</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading && !data.list.length ? (
                [...Array(6)].map((_, i) => (
                  <TableRow key={i}>
                    {[...Array(10)].map((__, idx) => (
                      <TableCell key={idx} sx={{ py: 1 }}>
                        <Skeleton variant="rectangular" animation="wave" height={28} sx={{ borderRadius: 1 }} />
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              ) : data.list.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={10} sx={{ py: 8, textAlign: "center" }}>
                    <Stack spacing={2} alignItems="center" justifyContent="center">
                      <Avatar sx={{ bgcolor: alpha(theme.palette.primary.main, 0.15), width: 64, height: 64 }}>
                        <MdInbox size={36} color={theme.palette.primary.main} />
                      </Avatar>
                      <Typography variant="h6" fontWeight={600} color="text.primary">
                        No Orders Found
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {searchQuery ? "Try different search terms or clear the filter." : "Currently no orders available."}
                      </Typography>
                    </Stack>
                  </TableCell>
                </TableRow>
              ) : (
                data.list.map((order) => {
                  const statusKey = order.status.toLowerCase();
                  const statusConfig = statusConfigs[statusKey] || statusConfigs.default;
                  const paymentConfig = paymentConfigs[order.paymentType] || paymentConfigs.default;
                  // Per-delivery-type label: 30-min countdown for Express,
                  // slot-aware for Scheduled, "Standard · 48–72 hrs" for
                  // courier orders.
                  const timingLabel =
                    getDeliveryTimingLabel(order) ||
                    getTimeStatus(order.createdAt);
                  const isTimeExceeded = String(timingLabel).includes(
                    "Time Exceeded"
                  );
                  const durationClass = isTimeExceeded
                    ? theme.palette.error.main
                    : theme.palette.text.secondary;
                  const durationWeight = isTimeExceeded ? "bold" : "normal";

                  return (
                    <TableRow
                      key={order._id}
                      hover
                      sx={{
                        transition: "all 0.3s ease",
                        "&:hover": {
                          boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.1)}`,
                          transform: "translateY(-3px)",
                          cursor: "pointer",
                          backgroundColor: alpha(theme.palette.primary.main, 0.05),
                        },
                        borderBottom: `1px solid ${alpha(theme.palette.divider, 0.15)}`,
                      }}
                    >
                      <TableCell
                        sx={{
                          fontFamily: "monospace",
                          fontWeight: 600,
                          fontSize: 13,
                          whiteSpace: "nowrap",
                        }}
                      >
                        <Box
                          sx={{
                            p: "2px 6px",
                            backgroundColor: alpha(theme.palette.primary.main, 0.1),
                            borderRadius: 1,
                            display: "inline-block",
                          }}
                        >
                          {order.orderId}
                        </Box>
                      </TableCell>

                      <TableCell
                        sx={{
                          fontSize: 13,
                          textTransform: "capitalize",
                          color: theme.palette.text.primary,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {order.orderType.replace("Pharmacy", "").trim()}
                      </TableCell>

                      <TableCell
                        sx={{
                          fontSize: 13,
                          fontWeight: 500,
                          maxWidth: 160,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {order.customerName}
                      </TableCell>

                      <TableCell
                        sx={{
                          fontSize: 13,
                          fontFamily: "monospace",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {order.customerPhone}
                      </TableCell>

                      <TableCell
                        align="right"
                        sx={{
                          fontSize: 13,
                          fontWeight: 700,
                          minWidth: 100,
                        }}
                      >
                        ₹{order.totalPrice.toLocaleString()}
                      </TableCell>

                      <TableCell>
                        <Chip
                          label={order.paymentType || "-"}
                          size="small"
                          sx={{
                            fontSize: 11,
                            fontWeight: 700,
                            color: paymentConfig.color,
                            backgroundColor: paymentConfig.bgColor,
                            borderRadius: 1,
                            px: 0.8,
                            py: 0.4,
                            textTransform: "uppercase",
                          }}
                        />
                      </TableCell>

                      <TableCell>
                        <Chip
                          label={order.status}
                          size="small"
                          icon={statusConfig.icon}
                          sx={{
                            fontSize: 11,
                            fontWeight: 700,
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            color: statusConfig.color,
                            backgroundColor: statusConfig.bgColor,
                            border: `1px solid ${alpha(statusConfig.color, 0.3)}`,
                            borderRadius: 1,
                            px: 0.8,
                            py: 0.4,
                            textTransform: "capitalize",
                          }}
                        />
                      </TableCell>

                      <TableCell>
                        {order.status === "Delivered" || order.status === "Order Cancelled" ? (
                          <Typography variant="caption" sx={{ color: "text.secondary" }}>
                            {getTimeStatusWithStatus(order.createdAt, order.updatedAt, order.status)}
                          </Typography>
                        ) : (
                          (() => {
                            const iconInfo = getDeliveryTimingIcon(order);
                            const TimingIcon = iconInfo
                              ? TimingIconMap[iconInfo.iconName]
                              : null;
                            return (
                              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                {TimingIcon ? (
                                  <TimingIcon
                                    sx={{
                                      fontSize: 14,
                                      color: isTimeExceeded
                                        ? theme.palette.error.main
                                        : iconInfo?.color || theme.palette.text.secondary,
                                    }}
                                  />
                                ) : null}
                                <Typography
                                  variant="caption"
                                  sx={{ color: durationClass, fontWeight: durationWeight }}
                                >
                                  {timingLabel}
                                </Typography>
                              </Box>
                            );
                          })()
                        )}
                      </TableCell>

                      <TableCell
                        sx={{
                          fontSize: 12,
                          whiteSpace: "nowrap",
                          textAlign: "center",
                          color: "text.secondary",
                          minWidth: 100,
                        }}
                      >
                        <Box>{dayjs(order.createdAt).format("MMM DD")}</Box>
                        <Box sx={{ fontSize: 10, opacity: 0.7 }}>{dayjs(order.createdAt).format("hh:mm A")}</Box>
                      </TableCell>

                      <TableCell align="center">
                        <Tooltip title="View Details">
                          <IconButton
                            size="small"
                            sx={{
                              color: theme.palette.primary.main,
                              backgroundColor: alpha(theme.palette.primary.main, 0.1),
                              transition: "all 0.3s ease",
                              "&:hover": {
                                backgroundColor: alpha(theme.palette.primary.main, 0.25),
                                transform: "scale(1.1)",
                                boxShadow: `0 6px 18px ${alpha(theme.palette.primary.main, 0.2)}`,
                              },
                            }}
                             onClick={() => navigate(`/admin/open-order/${order.orderId}`)}
                          >
                            <MdVisibility size={18} />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination Section */}
        <Box sx={{ p: 3, pt: 1, borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap" spacing={2}>
            <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
              Showing {data.list.length} of {data.totalCount} Orders
            </Typography>

            {data.totalPages > 1 && (
              <Pagination
                count={data.totalPages}
                page={currentPage}
                onChange={handlePageChange}
                siblingCount={0}
                boundaryCount={1}
                shape="rounded"
                color="primary"
                size={isMobile ? "small" : "medium"}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: MdArrowBack, next: MdArrowForward }}
                    {...item}
                    sx={{
                      minWidth: isMobile ? 28 : 36,
                      fontSize: isMobile ? 12 : 14,
                      borderColor: alpha(theme.palette.primary.main, 0.2),
                      "&.Mui-selected": {
                        bgcolor: theme.palette.primary.main,
                        color: medstownColors.white,
                        fontWeight: 700,
                        borderColor: theme.palette.primary.main,
                      },
                      "&:hover": {
                        bgcolor: alpha(theme.palette.primary.main, 0.1),
                        borderColor: alpha(theme.palette.primary.main, 0.4),
                      },
                    }}
                  />
                )}
              />
            )}
          </Stack>
        </Box>
      </Card>

      {/* Optional embedded component */}
      <PrescriptionOrder />
    </>
  );
};

export default OfferList;

